import { AgnesButton, AgnesPageHeader } from '@agnes/ui';
import { ChevronLeft, ClipboardList, Layers } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EmptyState } from '@/components/ui/EmptyState';
import { SectionCard } from '@/components/ui/SectionCard';
import type { EstadoAcaoEmMassa } from '@/pages/folha-pagamento/acao-em-massa/acaoEmMassa';
import { WizardAcaoEmMassa } from '@/pages/folha-pagamento/acao-em-massa/WizardAcaoEmMassa';

export const ROTA_RUBRICAS = '/esocial/rubricas';

export function PageRubricasAcaoEmMassa() {
  const navigate = useNavigate();
  const estado = useLocation().state as EstadoAcaoEmMassa | null;
  // Volta direto para a aba de onde a seleção saiu.
  const voltar = () => navigate(ROTA_RUBRICAS, { state: { aba: 'lote' } });

  return (
    <>
      <AgnesPageHeader
        icon={<ClipboardList />}
        dataQa="acao-massa-cabecalho"
        title="Ação em massa rubricas"
        subtitle="Altere em massa campos de recomendação e status de rubricas"
        breadcrumbs={[
          { label: 'Home', href: '/home' },
          { label: 'Folha de Pagamento' },
          { label: 'Rubricas', href: ROTA_RUBRICAS },
          { label: 'Ação em massa' },
        ]}
      />

      {estado?.rubricas?.length ? (
        <WizardAcaoEmMassa
          rubricas={estado.rubricas}
          origem={estado.origem}
          onCancelar={voltar}
          onConcluir={voltar}
        />
      ) : (
        <SectionCard data-qa="acao-massa-vazio" className="mt-6">
          <EmptyState
            icon={<Layers className="h-7 w-7" />}
            title="Nenhuma rubrica selecionada"
            description="Selecione rubricas na Análise em Lote para aplicar uma ação em massa."
          />
          <div className="flex justify-center pb-6">
            <AgnesButton
              dataQa="acao-massa-vazio-voltar"
              variant="outlined"
              startIcon={<ChevronLeft className="h-4 w-4" />}
              onClick={voltar}
            >
              Voltar para Rubricas
            </AgnesButton>
          </div>
        </SectionCard>
      )}
    </>
  );
}
